export default __webpack_public_path__ + "static/media/lightdarkthemes.9acdddfa.png";